.move-item-component {
  display: flex;
  align-items: center;
}
.move-item-component .avt-react-components--button {
  margin: 0 0.15rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9zcmMvc2NyaXB0L2NvbXBvbmVudHMvU2l0ZUFkbWluVmlldy9MYXlvdXRWaWV3L2NvbXBvbmVudHMvSXRlbUhhbmRsZXIiLCJzb3VyY2VzIjpbIkl0ZW1IYW5kbGVyLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBOztBQUVBO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIubW92ZS1pdGVtLWNvbXBvbmVudCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG5cbiAgLmF2dC1yZWFjdC1jb21wb25lbnRzLS1idXR0b24ge1xuICAgIG1hcmdpbjogMCAwLjE1cmVtO1xuICB9XG59XG4iXX0= */